module.exports = __webpack_public_path__ + "static/media/beon-air-logo-web.da9cc537.png";